/**
 * lib/views/javascripts/login/service-worker.js — clears stale service
 * workers and caches the first time the sign-in page loads.
 *
 * A service worker once pre-cached /?view=mobile before sign-in, then served
 * that cached /login redirect after a successful sign-in: an endless login
 * loop. If this page was served by a worker, it hard-reloads once after
 * unregistering so the next request bypasses it. The push worker is the one
 * registration kept: it has no fetch handler, its scope is /push/, and it
 * controls no pages, so it cannot serve a cached /login. It is also left out
 * of the count that triggers the reload, or its presence alone would reload
 * every fresh session.
 *
 * Contents: view
 * Ontology: Code object M33C-1030 (immutable ref — assigned once, never edit)
 * Team: J. Brant Arseneau & the Mach33 Agents.
 */

// ── Bust ─────────────────────────────────────────────────────────────────
export function bustServiceWorkers(pushWorkerPath, win = window) {
  const nav = win.navigator;
  if (!('serviceWorker' in nav)) return;
  const wasControlled = !!nav.serviceWorker.controller;
  nav.serviceWorker.getRegistrations().then((regs) => {
    const others = regs.filter((r) => {
      try {
        const url = (r.active && r.active.scriptURL) || (r.installing && r.installing.scriptURL) || '';
        return url.indexOf(pushWorkerPath) === -1;
      } catch { return true; }
    });
    const hadRegs = others.length > 0;
    others.forEach((r) => { try { r.unregister(); } catch { /* already gone */ } });
    try {
      if (win.caches && win.caches.keys) {
        win.caches.keys().then((keys) => { keys.forEach((k) => { win.caches.delete(k); }); });
      }
    } catch { /* caches unavailable */ }
    if ((wasControlled || hadRegs) && !win.sessionStorage.getItem('m33_sw_busted')) {
      win.sessionStorage.setItem('m33_sw_busted', '1');
      setTimeout(() => { win.location.reload(); }, 250);
    }
  }).catch(() => {});
}
